import { render } from "./FacebookLogoIcon.vue?vue&type=template&id=1976ae8c"
import script from "./FacebookLogoIcon.vue?vue&type=script&lang=js"
export * from "./FacebookLogoIcon.vue?vue&type=script&lang=js"

import "./FacebookLogoIcon.vue?vue&type=style&index=0&id=1976ae8c&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__